import path from 'path';
import { lazy } from 'react';
import { UserRole } from '../../config/rbac';

const VendorAdd = lazy(() => import('../../pages/admin/VendorAdd.tsx'));
const VendorEdit = lazy(() => import('../../pages/admin/VendorEdit.tsx'));
const VendorList = lazy(() => import('../../pages/admin/VendorList.tsx'));
const MenuEditor = lazy(() => import('../../pages/admin/MenuEditor.tsx'));
const QrCodeAssociation = lazy(() => import('../../pages/admin/QrCodeAssociation.tsx'));
const QrCodeGeneration = lazy(() => import('../../pages/admin/QrCodeGeneration.tsx'));
const QrCodeDashboard = lazy(() => import('../../pages/admin/QrCodeDashboard.tsx'));
const UserAdd = lazy(() => import('../../pages/admin/UserAdd.tsx'));
const UserList = lazy(() => import('../../pages/admin/UserList.tsx'));
const EditProfile = lazy(() => import('../../pages/admin/EditProfile.tsx'));
const PricingManagement = lazy(() => import('../../pages/admin/PricingManagement.tsx'));
const ProductCategoryManagement = lazy(() => import('../../pages/admin/ProductCategoryManagement.tsx'));
const MenuAvailabilityEditor = lazy(() => import('../../pages/admin/MenuAvailabilityEditor.tsx'));
const Analytics = lazy(() => import('../../pages/admin/Analytics.tsx'));
const VendorOrderPlacement = lazy(() => import('../../pages/admin/VendorOrderPlacement.tsx'));
const VendorPayment = lazy(() => import('../../pages/admin/VendorPayment.tsx'));
const SalesDashboard = lazy(() => import('../../pages/admin/SalesDashboard.tsx'));
const MySalesTracker = lazy(() => import('../../pages/admin/MySalesTracker.tsx'));
const VendorSubscriptions = lazy(() => import('../../pages/admin/VendorSubscriptions.tsx'));
const MySubscriptions = lazy(() => import('../../pages/admin/MySubscriptions.tsx'));

const coreRoutes = [
  {
    path: 'vendors',
    title: 'Vendor Management',
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION, UserRole.VENDOR],
    component: VendorList,
  },
  {
    path: 'vendor-add',
    title: 'Add Vendor',
    component: VendorAdd,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION],
  },
  {
    path: 'vendor/:vendorId/edit',
    title: 'Edit Vendor',
    component: VendorEdit,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION, UserRole.VENDOR],
  },
  {
    path: 'vendor/:vendorId/menu-edit',
    title: 'Menu Editor',
    component: MenuEditor,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION, UserRole.VENDOR],
  },
  {
    path: 'vendor/:vendorId/menu-availability',
    title: 'Menu Availability',
    component: MenuAvailabilityEditor,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION, UserRole.VENDOR],
  },
  {
    path: 'qrcode/associate/:qrId',
    title: 'Associate QR Code',
    component: QrCodeAssociation,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION],
  },
  {
    path: 'qrcode/generate',
    title: 'Generate QR Code',
    component: QrCodeGeneration,
    requiredRoles: [UserRole.ADMIN],
  },
  {
    path: 'qrcode/dashboard',
    title: 'QR Code Dashboard',
    component: QrCodeDashboard,
    requiredRoles: [UserRole.ADMIN],
  },
  {
    path: 'user/add/',
    title: 'Add User',
    component: UserAdd,
    requiredRoles: [UserRole.ADMIN],
  },
  {
    path: 'users',
    title: 'User List',
    component: UserList,
    requiredRoles: [UserRole.ADMIN],
  },
  {
    path: 'profile/',
    title: 'Edit Profile',
    component: EditProfile,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION, UserRole.VENDOR],
  },
  {
    path: 'pricing',
    title: 'Pricing Management',
    component: PricingManagement,
    requiredRoles: [UserRole.ADMIN],
  },
  {
    path: 'product-categories',
    title: 'Product Categories',
    component: ProductCategoryManagement,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION],
  },
  {
    path: 'analytics',
    title: 'Analytics',
    component: Analytics,
    requiredRoles: [UserRole.ADMIN],
  },
  {
    path: 'vendor-orders/create',
    title: 'Place Vendor Order',
    component: VendorOrderPlacement,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION],
  },
  {
    path: 'payment',
    title: 'Complete Payment',
    component: VendorPayment,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION],
  },
  {
    path: 'sales-dashboard',
    title: 'Sales Dashboard',
    component: SalesDashboard,
    requiredRoles: [UserRole.ADMIN],
  },
  {
    path: 'my-sales',
    title: 'My Sales',
    component: MySalesTracker,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION],
  },
  {
    path: 'my-subscriptions',
    title: 'My Subscriptions',
    component: MySubscriptions,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION, UserRole.VENDOR],
  },
  {
    path: 'subscriptions',
    title: 'Vendor Subscriptions',
    component: VendorSubscriptions,
    requiredRoles: [UserRole.ADMIN, UserRole.OPERATION],
  }
];

const routes = [...coreRoutes];
export default routes;